var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"text-center"},[_c('b-row',[_c('b-col',[_c('img',{staticClass:"w-100 h-auto",attrs:{"src":"https://cdn.vexels.com/img/licenses-available.svg","alt":_vm.$t('home.merch.header.licencesAlt'),"loading":"lazy","width":"700","height":"80"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }